import IntegrationTable from "@/components/shared/IntegrationTable/IntegrationTable";
import MundJetpack from "../icons/MundJetpack";
import JetpackIcon from "../icons/Jetpack";
import { integrationFieldPresets } from "@/components/shared/IntegrationTable/integrationFieldPresets";
import { useTranslation } from "react-i18next";

export default function Jetpack() {
  const { t } = useTranslation("common");
  return (
    <IntegrationTable
      integrationKey="jetpack"
      title="Jetpack (JetStream)"
      main_icon={<MundJetpack />}
      icon={<JetpackIcon />}
      fields={[
        integrationFieldPresets.access_token,
        integrationFieldPresets.secret_token,
        integrationFieldPresets.status,
      ]}
      fixedValues={{
        active_statuses: ["paid"],
      }}
      fieldLabels={{
        access_token: t("label_username"),
        placeholder_access_token: t("placeholder_username"),
        secret_token: t("label_password"),
        placeholder_secret_token: t("placeholder_password"),
      }}
    />
  );
}
